jQuery(function($)
{
    /**
	 * Accessible and configurable tooltips for specific elements
	 * @param {object} Target element
	 * @param {object} Tooltip options
	 */
    var Tooltip = function(element, options)
    {
        /**
		 * @type {function}
		 */
        this.show = orion.show;

        /**
		 * @type {function}
		 */
        this.hide = orion.hide;

        /**
		 * @type {jQuery}
		 */
        this.$tooltipElement = $(element);

        /**
		 * @type {Array}
		 */
        this.validTypes = ['focus', 'hover'];

        this.settings = $.extend({}, this.defaults, options);

        this.showTooltip = $.proxy(this.showTooltip, this);
        this.hideTooltip = $.proxy(this.hideTooltip, this);

        this.init();
    };

    /**
	 * Fetch data-tooltip-for-id attribute value
	 * @return {string} Value of data-tooltip-for-id attribute
	 */
    Tooltip.prototype.fetchForId = function()
    {
        return '#' + this.$tooltipElement.data('tooltipForId');
    };

    /**
	 * Fetch data-tooltip-type attribute value
	 * @return {string} Value of data-tooltip-type attribute
	 */
    Tooltip.prototype.fetchType = function()
    {
        var type = this.$tooltipElement.data('tooltipType');

        if ($.inArray(type, this.validTypes) === -1)
        {
            console.log('Invalid tooltip type \'' + type + '\'. Allowed types are: ' + this.validTypes.join(', '));
            return;
        }
        else
        {
            return type;
        }
    };

    /**
	 * Show tooltip element (remove class 'hidden')
	 */
    Tooltip.prototype.showTooltip = function()
    {
        if (this.$tooltipElement.hasClass('hidden'))
        {
            this.$tooltipElement.attr('aria-hidden', 'false');

            this.show(this.$tooltipElement);
        }
    };

    /**
	 * Hide tooltip element (remove class 'hidden')
	 */
    Tooltip.prototype.hideTooltip = function()
    {
        if (!this.$tooltipElement.hasClass('hidden'))
        {
            this.$tooltipElement.attr('aria-hidden', 'true');

            this.hide(this.$tooltipElement);
        }
    };

    /**
	 * Init events
	 */
    Tooltip.prototype.initEvents = function()
    {
        var
            forId = this.fetchForId(),
            type = this.fetchType();

        if (type == 'focus')
        {
            $(forId).focusin(this.showTooltip);
            $(forId).focusout(this.hideTooltip);
        }
        else if (type == 'hover')
        {
            $(forId).mouseenter(this.showTooltip);
            $(forId).mouseleave(this.hideTooltip);
        }
    };

    /**
	 * Initialize component
	 */
    Tooltip.prototype.init = function()
    {
        var
            forId = this.fetchForId(),
            type = this.fetchType();

        if ((type === 'focus' && $(forId).is(':focus')) || (type === 'hover' && $(forId).is(':hover')))
        {
            this.showTooltip();
        }

        this.initEvents();

        this.$tooltipElement.data('tooltip', this);
    };

    /**
	 * Initialize jQuery Plugin
	 * @param  {object} Tooltip options
	 * @return {object Tooltip} New Tooltip object
	 */
    $.fn.tooltip = function(options)
    {
        if ($(this).length)
        {
            return new Tooltip(this, options);
        }
    };

    // Tooltip for my Account
    var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
    var isWindows = /windows phone/i.test(navigator.userAgent.toLowerCase());
    var isBlackberry = /blackberry/i.test(navigator.userAgent.toLowerCase());
    var isiDevice = /ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase());

    function initTooltips()
    {
        if (isAndroid || isWindows || isBlackberry || isiDevice)
        {
            $(document).on('click', function(event)
            {
                // Schließe alle Tooltips, wenn außerhalb geklickt wird
                if (!$(event.target).closest('.js-tooltip-icon, .js-tooltip-content').length)
                {
                    $('.js-tooltip-content').addClass('hidden');
                }
            });

            $('.js-tooltip-icon').off('click');
            $('.js-tooltip-icon').on('click', function()
            {
                if ($(this).siblings('.js-tooltip-content').hasClass('hidden'))
                {
                    $(this).siblings('.js-tooltip-content').removeClass('hidden');
                }
                else
                {
                    $(this).siblings('.js-tooltip-content').addClass('hidden');
                }
            });

            $('.js-tooltip-close-icon').on('click', function()
            {
                $(this).closest('.js-tooltip-content').addClass('hidden');
            });
        }
        else
        {
            $('.js-tooltip-icon').hover(function()
            {
                $(this).siblings('.js-tooltip-content').removeClass('hidden');
            }, function()
            {
                $(this).siblings('.js-tooltip-content').addClass('hidden');
            });
        }
    }

    initTooltips();

    $('body').on(orion.constants.EventProductListReloaded, initTooltips);
    $('body').on(orion.constants.EventOrderlistItemLoaded, initTooltips);
});
